import axios from "../utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalizeListDurationForQuery } from "../utils/listTimePeriod";

export const sendInvite = createAsyncThunk(
  "merchant/invitation",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("merchant/invitation", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const sendAdminInvite = createAsyncThunk(
  "merchant/admin-invite",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("merchant/admin-invite", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getMerchantInviteByCode = createAsyncThunk(
  "merchant/invitation/code",
  async (code, thunkAPI) => {
    try {
      const response = await axios.get(`merchant/invitation/${code}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);
export const onboardExistingMerchant = createAsyncThunk(
  "merchant/onboard-existing-user",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(
        "merchant/onboard-existing-user",
        payload
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getMerchantInvites = createAsyncThunk(
  "merchant/invitations",
  async (payload, thunkAPI) => {
    try {
      const queryParams = new URLSearchParams();
      if (payload?.page) queryParams.append("page", payload.page);
      if (payload?.limit) queryParams.append("limit", payload.limit);
      if (payload?.search) queryParams.append("search", payload.search);
      if (payload?.status) queryParams.append("status", payload.status);
      const timeValue = normalizeListDurationForQuery(payload?.duration || payload?.timePeriod || payload?.dateFilter);
      if (timeValue) queryParams.append("duration", timeValue);

      const queryString = queryParams.toString();
      const url = queryString ? `merchant/invitations?${queryString}` : "merchant/invitations";
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const startOnboarding = createAsyncThunk(
  "merchant/startProcessStatus",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("merchant/startProcessStatus", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const saveMerchantData = createAsyncThunk(
  "merchant/savePotentialMerchant",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(
        `merchant/savePotentialMerchant/${payload?.id}`,
        payload
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getPotentialMerchant = createAsyncThunk(
  "merchant/get",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get(`merchant/potential/${payload?.id}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const createPotentialMerchant = createAsyncThunk(
  "merchant/potential",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(
        `merchant/potential/${payload?.id}`,
        payload
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const merchantOnboard = createAsyncThunk(
  "merchant/onboard",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("merchant/onboard", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const sendFundraiserInvite = createAsyncThunk(
  "fundraiser/invitation",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("fundraiser/invitation", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

// Validate fundraiser invitation link before showing the form
export const startFundraiserOnboarding = createAsyncThunk(
  "fundraiser/startProcessStatus",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("fundraiser/startProcessStatus", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getReasons = createAsyncThunk(
  "reason",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get(
        `reason?isApproved=${payload?.isApproved}`
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const createReason = createAsyncThunk(
  "reason/create",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("reason", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const fundraiserOnboard = createAsyncThunk(
  "fundraiser/onboard",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("fundraiser/onboard", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getFundraiserResubmitApplication = createAsyncThunk(
  "fundraiser/resubmit/get",
  async (token, thunkAPI) => {
    try {
      const response = await axios.get(`fundraiser/resubmit/${token}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const resubmitFundraiserApplication = createAsyncThunk(
  "fundraiser/resubmit/submit",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.patch(
        `fundraiser/resubmit/${payload?.token}`,
        payload?.data
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);
